import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "a-auth full-height" }
const _hoisted_2 = { class: "ion-padding a-auth__content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "load-wrap ion-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "ion-no-padding ion-padding-bottom",
        fullscreen: true,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Reset password", -1)),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.code))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Code", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.code) = $event)),
                    class: "ion-padding-vertical",
                    name: "code",
                    type: "text",
                    onIonBlur: _cache[1] || (_cache[1] = ($event: any) => ($options.onBlur($data.v.code)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.email))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Email", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.email) = $event)),
                    class: "ion-padding-vertical",
                    name: "code",
                    type: "email",
                    onIonBlur: _cache[3] || (_cache[3] = ($event: any) => ($options.onBlur($data.v.email)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.password))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Password", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.password) = $event)),
                    class: "ion-padding-vertical",
                    name: "password",
                    type: "password",
                    onIonBlur: _cache[5] || (_cache[5] = ($event: any) => ($options.onBlur($data.v.password)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.confirmPassword))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Confirm password", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.confirmPassword,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.confirmPassword) = $event)),
                    class: "ion-padding-vertical",
                    name: "password",
                    type: "password",
                    onIonBlur: _cache[7] || (_cache[7] = ($event: any) => ($options.onBlur($data.v.confirmPassword)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", { class: "lds-roller" }, [
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div")
                    ], -1),
                    _createElementVNode("p", null, "Loading...", -1)
                  ]))]))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    disabled: $options.isFormInvalid,
                    class: "--default a-auth__button ion-margin-vertical",
                    onClick: $options.reset
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("Reset my password", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}